<div class="h-full">
	<!-- Header -->
	<div class="flex flex-col mobile_landscape:items-center" [ngClass]="isMobile ? 'h-[100vh]' : 'min-h-[700px]'">
		<div class="flex flex-col mobile_landscape:items-center laptop:flex-row laptop:items-center laptop:justify-center laptop:max-w-[1080px] h-full">
			<div class="hidden laptop:flex flex-col w-full laptop:w-auto laptop:flex-1 h-[650px]">
				<div class="relative h-full flex flex-col justify-center">
					<div class="flex flex-col justify-center p-auto tablet:w-full">
						<div class="w-1/2 min-w-[250px]">
							<h3 [style.line-height]="1.25" [style.font-size]="'36px'" class="max-w-[250px]">
								<b>{{ 'gotMinute' | translate }}</b>
							</h3>
							<p class="leading-5 min-w-[250px] font-normal text-[18px]">{{ 'socialMedia' | translate }}</p>
						</div>
					</div>
					<img *ngIf="responseService.currentPage?.screen === SCREENS.WELCOME_SCREEN" class="absolute bottom-0 mb-3 w-[250px]" style="right: 24px"
                         src="assets/images/share-thoughts.png" />
				</div>
			</div>
			<div class="laptop:w-auto laptop:flex-1 mobile:w-full mobile_landscape:min-w-[370px] mobile_landscape:max-w-[370px] flex flex-col mobile_landscape:items-center" id="jottoWelcome">
				<div class="flex justify-center p-auto">
					<div class="w-full">
						<ng-container *ngIf="!ready" class="flex justify-center">
							<div class="flex items-center" [ngClass]="isMobile ? 'h-[100vh]' : 'min-h-[700px]'">
								<ngx-skeleton-loader
									appearance="custom-content"
									animation="progress-dark"
									[theme]="{
										height: isMobile ? '100vh' : '650px',
										width: isMobile ? '100%' : '370px',
										'border-radius': isMobile ? 'none' : '24px',
										'margin-bottom': '0px',
										background: 'var(--portals-theme-highlight)'
									}"
								></ngx-skeleton-loader>
							</div>
						</ng-container>
						<ng-container *ngIf="responseService.currentPage?.screen === SCREENS.WELCOME_SCREEN">
							<jotto-app-welcome [scrollable]="isMobile" (scrollContent)="scrollDiv()"></jotto-app-welcome>
						</ng-container>
						<ng-container *ngIf="responseService.currentPage?.screen === SCREENS.RESPONSE_SCREEN">
							<portals-notifications-response></portals-notifications-response>
						</ng-container>
						<ng-container *ngIf="responseService.currentPage?.screen === SCREENS.UPLOADING_SCREEN">
							<jotto-app-upload-notice></jotto-app-upload-notice>
						</ng-container>
						<ng-container *ngIf="responseService.currentPage?.screen === SCREENS.CHANNEL_FEED_SCREEN">
							<jotto-app-channel-feed [maxFeedHeight]="deviceService.isDesktop() ? '650px' : '700px'"></jotto-app-channel-feed>
						</ng-container>
					</div>
				</div>
			</div>
			<div class="hidden laptop:flex flex-col w-full laptop:w-auto laptop:flex-1 h-[650px]">
				<div class="flex justify-end h-full items-center self-center p-auto tablet:w-full">
					<div class="w-1/2 min-w-[250px] justify-center items-center flex flex-col">
						<div *ngIf="channel && !notification?.qr_code?.url">
							<div style="position: relative; height: 150px; width: 150px; margin: auto">
								<div style="position: absolute">
									<qrcode [qrdata]="url" [allowEmptyString]="true" [cssClass]="'center'" [colorDark]="qrCodeColor.dark" [colorLight]="qrCodeColor.light" [errorCorrectionLevel]="'H'" elementType="png" [scale]="1" [width]="150" [margin]="2"></qrcode>
								</div>
								<svg style="transform: translate(0%, 0%); width: 150px; height: 150px">
									<image [attr.href]="'/assets/images/jotto-yellow.svg'" width="50" height="50" style="transform: translate(50px, 50px)"></image>
								</svg>
							</div>
						</div>
                        <img *ngIf="channel && notification?.qr_code?.url" [src]="notification?.qr_code?.url" [ngStyle]="{ width: '150px', height: '150px' }"/>
                        <p class="leading-none max-w-[160px] mt-2 text-center font-normal text-[14px]">{{ 'desktopRightDescription' | translate }}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="flex tablet:flex-row items-start justify-center laptop:hidden">
			<div class="basis-1/2 hidden tablet:flex">
				<div class="flex justify-center p-auto w-full">
					<div class="w-1/2 min-w-[250px]">
						<h3 [style.line-height]="1.25" [style.font-size]="'36px'">
							<b>{{ 'gotMinute' | translate }}</b>
						</h3>
						<p class="leading-5 font-normal text-[18px]">{{ 'socialMedia' | translate }}</p>
					</div>
				</div>
			</div>
			<div class="basis-1/2 hidden tablet:flex">
				<div class="flex justify-center p-auto w-full">
					<div class="w-1/2 min-w-[250px] flex flex-col items-center">
						<div class="qr-code" *ngIf="channel && !notification?.qr_code?.url">
							<div style="position: relative; height: 200px; width: 200px; margin: auto">
								<div style="position: absolute">
									<qrcode #qrCode [qrdata]="url" [allowEmptyString]="true" [cssClass]="'center'" [colorDark]="qrCodeColor.dark" [colorLight]="qrCodeColor.light" [errorCorrectionLevel]="'H'" elementType="png" [scale]="1" [width]="200" [margin]="2"></qrcode>
								</div>
								<svg style="transform: translate(0%, 0%); width: 200px; height: 200px">
									<image [attr.href]="'/assets/images/jotto-yellow.svg'" width="50" height="50" style="transform: translate(75px, 75px)"></image>
								</svg>
							</div>
							<div style="display: none" #qrCodeContainer></div>
						</div>
                        <img *ngIf="channel && notification?.qr_code?.url" [src]="notification?.qr_code?.url" [ngStyle]="{ width: '200px', height: '200px' }"/>
                        <div class="mt-4 text-center w-[200px]">
							<h3 [style.line-height]="1" class="text-center font-normal text-[18px] tablet:text-[22px]">{{ 'downloadJotto' | translate }}</h3>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="isSTV && wordCount.words[0] && false" class="hidden laptop:flex laptop:max-w-[1080px] laptop:w-[100%] my-14 align-items-center justify-center">
			<div class="flex flex-col ml-0 p-auto tablet:w-[40%] w-[250px]">
				<h3 [style.line-height]="1.25" [style.font-size]="'36px'" class="max-w-[250px]">
					<b>{{ 'wordCloudTextTitle' | translate }}</b>
				</h3>
				<!--<p class="leading-5 max-w-[250px] font-normal text-[18px]">{{ 'wordCloudTextDescription' | translate }}</p>
				<button class="rounded-full mt-4 bg-portals-theme-accent py-[8px] w-[150px]" (click)="scrollToTop()">
					<span class="ml-4 mr-4 font-black"> <b>{{ 'letsGoSmall' | translate }}</b></span>
				</button>
				<p class="ml-2 leading-none mt-2 max-w-[160px] font-normal text-[10px]">{{ 'termsAgreement' | translate }}</p>-->
			</div>
			<div class="p-auto tablet:w-full">
				<portals-word-cloud width="100%" *ngIf="wordCount?.words?.[0]" [data]="wordCount"></portals-word-cloud>
			</div>
		</div>
	</div>

	<!-- Mobile grayed actions -->
	<div class="mobile:flex flex-col justify-start px-5 pb-5 tablet:hidden" id="grayPortion">
		<h1 class="tablet:hidden mobile:block mt-2 mb-3 w-full text-left" [style.line-height]="'36px'" [style.font-size]="'32px'">
			<b>{{ 'gotCommentFull' | translate }}</b>
		</h1>
		<h1 class="tablet:block mobile:hidden mt-2 mb-3 w-full text-left" [style.line-height]="'36px'" [style.font-size]="'32px'">
			<b>{{ 'gotCommentFull' | translate }}</b>
		</h1>
		<div class="flex flex-col tablet:flex-row w-full h-full">
			<div class="tablet:basis-1/2 mt-2 mb-0">
				<div class="flex justify-start p-auto">
					<div class="w-full flex flex-col items-start">
						<img class="mobile:w-[92px] tablet:w-[152px] mb-3" src="{{ 'image1' | translate }}" />
						<p class="text-[16px] leading-5 mobile_landscape:text-[24px] tablet:text-[32px] mobile_landscape:leading-6 tablet:leading-6">
							{{ 'socialMediaBr' | translate }}
							<br />
							{{ 'outletAmplify' | translate }}
							<br />
							{{ 'voices' | translate }}
							<br />
							{{ 'discourse' | translate }}
						</p>
					</div>
				</div>
			</div>
			<div class="tablet:basis-1/2 mt-2 mb-0">
				<div class="flex justify-start p-auto">
					<div class="w-full flex flex-col items-start">
						<img class="mobile:w-[92px] tablet:w-[152px] mb-3" src="{{ 'image2' | translate }}" />
						<p class="text-[16px] leading-5 mobile_landscape:text-[24px] tablet:text-[32px] mobile_landscape:leading-6 tablet:leading-6">
							{{ 'itsTime' | translate }}
							<br />
							{{ 'conversationJoe' | translate }}
							<br />
							{{ 'addressIssues' | translate }}
							<br />
							{{ 'challengesMatterMost' | translate }}
							<br />
							{{ 'toYou' | translate }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- {{environment.whiteLabel || 'Jotto'}} Images -->
	<div class="hidden laptop:flex flex-col items-center justify-center bg-[#E5E7EB]">
		<div class="flex flex-col items-center laptop:max-w-[1280px]">
			<h1 class="mb-5 mt-5 w-full text-center" [style.line-height]="1.25" [style.font-size]="'36px'">
				<b>{{ 'preference' | translate }}</b>
			</h1>
			<div class="laptop:flex laptop:flex-row laptop:items-center h-full">
				<div class="basis-1/3 px-2 py-4">
					<div class="flex justify-center p-auto">
						<div class="w-[320px] flex flex-col items-center">
							<div class="relative">
								<ng-container *ngIf="!ready; else audioLoaded">
									<ngx-skeleton-loader
										appearance="custom-content"
										animation="progress-dark"
										[theme]="{
											height: '532.5px',
											width: '300px',
											'border-radius': '24px',
											'margin-bottom': '0px',
											background: 'var(--portals-theme-highlight)'
										}"
									></ngx-skeleton-loader>
								</ng-container>
								<ng-template #audioLoaded>
									<img class="w-[300px]" src="assets/images/audio-response.png" />
									<div class="w-[300px] absolute top-15 transform -translate-x-1/2">
										<web-cta [channel]="channel" [notification]="notification" [ctaText]="'sendAudio' | translate"></web-cta>
									</div>
								</ng-template>
							</div>
							<div class="flex justify-center mt-3 mb-5">
								<button class="py-[8px] px-[24px] rounded-full border-solid border-2 border-portals-primary-900 border-black" (click)="scrollToTop()"><b class="ml-3 mr-3"
                                                                                                                                                                         [style.font-weight]="700">{{'audioButton' | translate}}</b></button>
							</div>
						</div>
					</div>
				</div>
				<div class="basis-1/3 px-2 py-4">
					<div class="flex justify-center p-auto">
						<div class="w-[320px] flex flex-col items-center">
							<div class="relative">
								<ng-container *ngIf="!ready; else videoLoaded">
									<ngx-skeleton-loader
										appearance="custom-content"
										animation="progress-dark"
										[theme]="{
											height: '532.5px',
											width: '300px',
											'border-radius': '24px',
											'margin-bottom': '0px',
											background: 'var(--portals-theme-highlight)'
										}"
									></ngx-skeleton-loader>
								</ng-container>
								<ng-template #videoLoaded>
									<img class="w-[300px]" src="assets/images/video-response.png" />
									<div class="w-[300px] absolute top-15 transform -translate-x-1/2">
										<web-cta [channel]="channel" [notification]="notification" [ctaText]="'sendVideo' | translate"></web-cta>
									</div>
								</ng-template>
							</div>
							<div class="flex justify-center mt-3 mb-5">
								<button class="py-[8px] px-[24px] rounded-full border-solid border-2 border-portals-primary-900 border-black" (click)="scrollToTop()"><b class="ml-3 mr-3"
                                                                                                                                                                         [style.font-weight]="700">{{'videoButton' | translate}}</b></button>
							</div>
						</div>
					</div>
				</div>
				<div class="basis-1/3 px-2 py-4">
					<div class="flex justify-center p-auto">
						<div class="w-[320px] flex flex-col items-center">
							<div class="relative">
								<ng-container *ngIf="!ready; else textLoaded">
									<ngx-skeleton-loader
										appearance="custom-content"
										animation="progress-dark"
										[theme]="{
											height: '532.5px',
											width: '300px',
											'border-radius': '24px',
											'margin-bottom': '0px',
											background: 'var(--portals-theme-highlight)'
										}"
									></ngx-skeleton-loader>
								</ng-container>
								<ng-template #textLoaded>
									<img class="w-[300px]" src="assets/images/text-response.png" />
									<div class="w-[300px] absolute top-15 transform -translate-x-1/2">
										<web-cta [channel]="channel" [notification]="notification" [ctaText]="'sendText' | translate"></web-cta>
									</div>
								</ng-template>
							</div>
							<div class="flex justify-center mt-3 mb-5">
								<button class="py-[8px] px-[24px] rounded-full border-solid border-2 border-portals-primary-900 border-black" (click)="scrollToTop()"><b class="ml-3 mr-3"
                                                                                                                                                                         [style.font-weight]="700">{{'textButton' | translate}}</b></button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- {{environment.whiteLabel || 'Jotto'}} Images Mobile -->
	<div class="mobile:flex flex-col items-center justify-center bg-[#E5E7EB] p-5 laptop:hidden">
		<h1 class="py-4 mb-0 w-full tablet:text-center" [style.line-height]="1.25" [style.font-size]="'32px'">
			<b>{{ 'preference' | translate }}</b>
		</h1>
		<div class="laptop:flex laptop:flex-row laptop:items-center h-full laptop:max-w-[1280px]">
			<div class="basis-1/3 p-4">
				<div class="flex justify-center p-auto">
					<div class="w-[320px]">
						<div class="relative" (click)="scrollToTop()">
							<img class="w-[320px]" src="assets/images/audio-jotto.png" />
							<div class="w-[320px] absolute top-15 transform -translate-x-1/2">
								<web-cta [channel]="channel" [notification]="notification" [ctaText]="'sendAudio' | translate"></web-cta>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="basis-1/3 p-4">
				<div class="flex justify-center p-auto">
					<div class="w-[320px]">
						<div class="relative" (click)="scrollToTop()">
							<img class="w-[320px]" src="assets/images/video-jotto.png" />
							<div class="w-[320px] absolute top-15 transform -translate-x-1/2">
								<web-cta [channel]="channel" [notification]="notification" [ctaText]="'sendVideo' | translate"></web-cta>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="basis-1/3 p-4">
				<div class="flex justify-center p-auto">
					<div class="w-[320px]">
						<div class="relative" (click)="scrollToTop()">
							<img class="w-[320px]" src="assets/images/text-jotto.png" />
							<div class="w-[320px] absolute top-15 transform -translate-x-1/2">
								<web-cta [channel]="channel" [notification]="notification" [ctaText]="'sendText' | translate"></web-cta>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- The silhouotte laptop -->
	<div class="hidden laptop:flex flex-col items-center">
		<div class="flex flex-row items-center laptop:justify-center laptop:max-w-[1280px]">
			<div class="bg-scroll h-2/3 w-full bg-contain bg-no-repeat px-4">
				<div class="flex flex-row items-end">
					<div class="w-1/3 h-auto">
						<img [src]="'/assets/images/silhoutte-head.png'" class="relative w-full" />
					</div>
					<div class="w-2/3 pb-4">
						<h1 class="mt-5 text-portals-theme-accent laptop:text-black max-tablet:pt-[50px] max-tablet:pb-[50px]" [style.line-height]="1.25" [style.font-size]="'40px'">
							<b>
								{{ 'lettingJoeKnow' | translate }}
								<br />
								{{ 'easierOrSafer' | translate }}
							</b>
						</h1>
						<h2>{{ 'respectPrivacy' | translate }}</h2>

						<div class="grid tablet:grid-cols-3 tablet:gap-1">
							<h4 class="leading-none">
								<b class="text-portals-theme-status-expired">NO</b>
								{{ 'registration' | translate }}
							</h4>
							<h4 class="leading-none">
								<b class="text-portals-theme-status-expired">NO</b>
								{{ 'flName' | translate }}
							</h4>
							<h4 class="leading-none">
								<b class="text-portals-theme-status-expired">NO</b>
								{{ 'phoneNumber' | translate }}
							</h4>
							<h4 class="leading-none">
								<b class="text-portals-theme-status-expired">NO</b>
								{{ 'birthDates' | translate }}
							</h4>
							<h4 class="leading-none">
								<b class="text-portals-theme-status-expired">NO</b>
								{{ 'physicalAddresses' | translate }}
							</h4>
							<h4 class="leading-none">
								<b class="text-portals-theme-status-expired">NO</b>
								{{ 'emailAddress' | translate }}
							</h4>
							<h4 class="leading-none">
								<b class="text-portals-theme-status-expired">NO</b>
								{{ 'pins' | translate }}
							</h4>
							<h4 class="leading-none">
								<b class="text-portals-theme-status-expired">NO</b>
								{{ 'Password' | translate }}
							</h4>
							<h4 class="leading-none text-portals-theme-status-expired">
								<b [style.font-weight]="700">NO {{ 'nothing' | translate }}!</b>
							</h4>
						</div>

						<div class="laptop:mt-3">
							<button class="rounded-full bg-portals-theme-accent py-[8px] px-[24px]" (click)="scrollToTop()">
								<span>
									<b class="ml-4 mr-4">{{ 'letsGoSmall' | translate }}</b>
								</span>
							</button>
						</div>
					</div>
				</div>
				<div *ngIf="isMobile">
					<h2 [style.line-height]="1.25" [style.font-size]="'28px'"><b>{{ 'weOnlyKnow' | translate }}</b></h2>
					<h4 [style.line-height]="1" [style.font-size]="'16px'">{{ 'upToYou' | translate }}</h4>
					<h4 [style.line-height]="1" [style.font-size]="'16px'">{{ 'yourIdeas' | translate }}</h4>
				</div>
			</div>
		</div>
	</div>

	<!-- The silhoutte mobile -->
	<div class="mobile:block relative h-2/3 px-5 py-4 bg-portals-theme-surface laptop:hidden tablet:hidden">
		<div class="flex flex-row-reverse">
			<div class="mb-2 w-full">
				<img [src]="'/assets/images/woman-with-words.png'" class="relative w-[100%] tablet:w-[50%] mx-auto mb-[40px]" />
				<h2 class="mt-6 mb-2 font-portals font-medium" [style.font-size]="'24px'" [style.line-height]="'20px'" [style.font-weight]="500">{{ 'weWontKnow' | translate }}</h2>
				<p class="font-normal" [style.line-height]="'20px'" [style.font-size]="'16px'">
					{{ 'respectPrivacy' | translate }}
				</p>

				<div class="grid laptop:grid-cols-3 tablet:grid-cols-3 laptop:gap-2 tablet:gap-2">
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>
						{{ 'registration' | translate }}
					</h4>
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>
						{{ 'flName' | translate }}
					</h4>
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>
						{{ 'phoneNumber' | translate }}
					</h4>
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>
						{{ 'birthDates' | translate }}
					</h4>
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>

						{{ 'physicalAddresses' | translate }}
					</h4>
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>
						{{ 'emailAddress' | translate }}
					</h4>
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>
						{{ 'pins' | translate }}
					</h4>
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>
						{{ 'Password' | translate }}
					</h4>
					<h4 class="leading-none text-portals-theme-status-expired">
						<b>NO {{ 'nothing' | translate }}!</b>
					</h4>
				</div>
			</div>
		</div>
		<div *ngIf="isMobile">
			<h1 class="mt-2 mb-2 font-semibold" [style.font-size]="'24px'" [style.line-height]="'20px'" [style.font-weight]="500">{{ 'weOnlyKnow' | translate }}</h1>
			<h4 [style.line-height]="1" [style.font-size]="'16px'" class="my-4 font-portals">{{ 'upToYou' | translate }}</h4>
			<h4 [style.line-height]="1" [style.font-size]="'16px'" class="font-bold font-portals" [style.font-weight]="500">{{ 'yourIdeas' | translate }}</h4>
		</div>
	</div>

	<!-- The silhoutte tablet -->
	<div class="tablet:block relative h-2/3 px-4 py-4 bg-portals-theme-surface laptop:hidden mobile:hidden">
		<div class="flex flex-row-reverse">
			<div class="mb-2 w-full">
				<div class="flex flex-row mx-auto mb-[40px]">
					<div class="basis-1/3">
						<img [src]="'/assets/images/silhoutte-head.png'" class="relative w-full" />
					</div>
					<div class="basis-2/3 flex flex-col justify-end">
						<h1 class="mt-5 text-black max-tablet:pt-[50px] max-tablet:pb-[50px]" [style.line-height]="1.25" [style.font-size]="'40px'">
							<b>
								{{ 'lettingJoeKnow' | translate }}
								<br />
								{{ 'easierOrSafer' | translate }}
							</b>
						</h1>
						<h2>{{ 'respectPrivacy' | translate }}</h2>
					</div>
				</div>

				<div class="grid mobile:grid-cols-2 laptop:grid-cols-3 tablet:grid-cols-3 mobile:gap-1 laptop:gap-1 tablet:gap-1">
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>
						Registration
					</h4>
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>
						First or Last Names
					</h4>
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>
						Phone numbers
					</h4>
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>
						Birthdates
					</h4>
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>
						Physical addresses
					</h4>
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>
						Email addresses
					</h4>
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>
						PINs
					</h4>
					<h4 class="leading-none">
						<b class="text-portals-theme-status-expired">No</b>
						Passwords
					</h4>
					<h4 class="leading-none text-portals-theme-status-expired">
						<b>NO NOTHING!</b>
					</h4>
				</div>
			</div>
		</div>
		<div *ngIf="isMobile">
			<h1 class="mt-2 mb-2 font-semibold" [style.font-size]="'24px'" [style.line-height]="'20px'" [style.font-weight]="500">{{ 'weOnlyKnow' | translate }}</h1>
			<h4 [style.line-height]="1" [style.font-size]="'16px'" class="my-4 font-portals">It's up to you how much personal information you wish to share; for instance what you say when you record a story or if you opt in to share your location.</h4>
			<h4 [style.line-height]="1" [style.font-size]="'16px'" class="font-bold font-portals" [style.font-weight]="500">Your ideas are what’s important so that’s all we know about you.</h4>
		</div>
	</div>

	<!-- You control what you share -->
	<div class="hidden tablet:flex flex flex-row justify-center items-center bg-[#291536]">
		<div class="flex flex-row items-center laptop:max-w-[1280px]">
			<div class="tablet:flex tablet:flex-row tablet:items-center h-full w-full px-4">
				<div class="w-auto py-10">
					<div class="flex justify-start p-auto">
						<div class="w-2/3">
							<h1 class="text-portals-theme-on-primary" [style.line-height]="1.25" [style.font-size]="'36px'">
								<b>{{ 'controlShare' | translate }}</b>
							</h1>
							<div class="mt-3 mb-5">
								<button class="rounded-full bg-portals-theme-accent py-[8px] px-[24px]" (click)="scrollToTop()">
									<span>
										<b class="ml-4 mr-4">{{ 'letsGoSmall' | translate }}</b>
									</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="w-[375px] border-x-2 border-y-0 border-solid border-white">
					<div class="flex justify-center p-x-auto py-10">
						<div>
							<web-cta [channel]="channel" [notification]="notification" ctaText="{{ 'weOnlyKnow' | translate }}"></web-cta>
							<div class="flex justify-center mt-15 mb-5 px-6 laptop:max-w-[520px]">
								<div class="bg-portals-theme-accent rounded-lg p-[16px]">
									<p [style.line-height]="'normal'" class="text-black mb-0 font-semibold text-[10px]">
										{{ 'upToYou' | translate }}
										<br />
										<br />
										{{ 'yourIdeas' | translate }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Stay in the loop laptop -->
	<div class="hidden tablet:flex flex flex-col pb-5 justify-center items-center">
		<h1 class="mt-5 w-1/2 text-center" [style.font-size]="'36px'"><b>{{ 'wantToStayIn' | translate }} {{ 'theLoop' | translate }}</b></h1>
		<div class="tablet:flex tablet:flex-row tablet:items-center laptop:max-w-[1280px] h-full">
			<div class="basis-1/3">
				<div class="flex justify-end p-auto">
					<div class="w-3/4">
						<p [style.line-height]="'32px'" class="font-normal text-[16px] tablet:text-[24px]">
							<b>{{ 'downloadJotto' | translate }}</b>
						</p>
					</div>
				</div>
			</div>
			<div class="basis-1/3 mt-12">
				<div class="flex justify-center p-auto">
					<div class="w-auto">
						<div class="qr-code" *ngIf="channel && !notification?.qr_code?.url">
							<div style="position: relative; height: 200px; width: 200px; margin: auto">
								<div style="position: absolute">
									<qrcode #qrCode [qrdata]="url" [allowEmptyString]="true" [cssClass]="'center'" [colorDark]="qrCodeColor.dark" [colorLight]="qrCodeColor.light" [errorCorrectionLevel]="'H'" elementType="png" [scale]="1" [width]="200" [margin]="2"></qrcode>
								</div>
								<svg style="transform: translate(0%, 0%); width: 200px; height: 200px">
									<image [attr.href]="'/assets/images/jotto-yellow.svg'" width="50" height="50" style="transform: translate(75px, 75px)"></image>
								</svg>
							</div>
							<div style="display: none" #qrCodeContainer></div>
						</div>
                        <img class="mx-auto" *ngIf="channel && notification?.qr_code?.url" [src]="notification?.qr_code?.url" [ngStyle]="{ width: '200px', height: '200px' }"/>

                        <div class="mt-4">
							<p class="text-center font-medium text-[16px] text-portals-theme-primary-text">{{'install' | translate }}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="basis-1/3">
				<div class="flex justify-start p-auto">
					<div class="w-full">
						<p [style.line-height]="'22px'" class="font-medium text-[18px]">
							<span [style.font-weight]="700">{{ 'be' | translate }}</span>
							{{ 'thefirst' | translate }}
						</p>
						<!--						<br />-->
						<p [style.line-height]="'22px'" class="font-medium text-[18px]">
							<span [style.font-weight]="700">{{ 'share' | translate }}</span>
							{{ 'feedbackAnytimeAnywhere' | translate }}
						</p>
						<!--						<br />-->
						<p [style.line-height]="'22px'" class="font-medium text-[18px]">
							<span [style.font-weight]="700">{{ 'respond' | translate }}</span>
							{{ 'toFollowUpQuestion' | translate }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Stay in the loop mobile -->
	<div class="mobile:flex bg-[#E5E7EB] px-5 py-4 flex-col tablet:hidden">
		<div>
			<h1 [style.font-size]="'32px'" [style.font-weight]="600" [style.line-height]="'36px'">
				{{ 'wantToStayIn' | translate }}
				<br />
				{{ 'theLoop' | translate }}
			</h1>
			<h3 [style.font-size]="'16px'" [style.font-weight]="500" [style.line-height]="'20px'">
				<b>
					{{ 'downloadJotto' | translate }}
				</b>
				<br />
			</h3>
			<h4 [style.font-size]="'16px'" [style.line-height]="'20px'">
				<span [style.font-weight]="600">{{ 'be' | translate }}</span>
				{{ 'thefirst' | translate }}
			</h4>
			<h4 [style.font-size]="'16px'" [style.line-height]="'20px'">
				<span [style.font-weight]="600">{{ 'share' | translate }}</span>
				{{ 'feedbackAnytimeAnywhere' | translate }}
			</h4>
			<h4 [style.font-size]="'16px'" [style.line-height]="'20px'">
				<span [style.font-weight]="600">
					{{ 'respond' | translate }}
				</span>
				{{ 'toFollowUpQuestion' | translate }}
			</h4>
		</div>
		<!--<div class="flex flex-row w-full justify-center mt-8">
			<button class="bg-[#FBD354] w-6/12 rounded-3xl py-3 text-[14px] font-semibold" (click)="linkService.installJotto(channelUUID, url, LINK_TYPES.CHANNEL)">Install {{ environment.whiteLabel
               || 'Jotto' }}</button>
		</div>-->
	</div>

	<!-- Footer -->
	<div class="flex flex-col tablet:w-[100vw] justify-center items-center bg-portals-theme-accent">
		<div class="tablet:my-[80px] tablet:w-full mobile:w-[80%] mobile:my-[40px] justify-center items-start flex tablet:flex-row mobile:flex-col tablet:mb-0 mobile:mb-10">
			<div class="tablet:mr-[110px]">
				<h3 [style.line-height]="1.25" [style.font-size]="isMobile ? '32px' : '36px'" class="tablet:max-w-[375px] mobile:max-w-[250px]">
					<b>{{ 'wantRealInsight' | translate }}</b>
				</h3>
			</div>
			<p class="tablet:max-w-[530px] mobile:max-w-[250px] tablet:leading-8 mobile:text-[16px] tablet:text-[24px]">{{ 'jottoHelps' | translate }}</p>
		</div>
		<div class="mobile:w-[80%] tablet:w-full mobile:mb-[40px] tablet:mb-0 justify-center tablet:items-end mobile:items-start flex tablet:flex-row mobile:flex-col mobile:space-y-6">
			<div class="tablet:flex tablet:mr-[150px] tablet:flex-col tablet:justify-center tablet:items-center">
				<img class="tablet:m-5 tablet:h-[85px] mobile:h-[80px] w-[45px]" src="/assets/images/phone-screen.png" />
				<p class="mobile:font-bold text-center tablet:font-light mobile:text-[16px] tablet:text-[24px]">{{ 'convenientAccess' | translate }}</p>
			</div>
			<div class="tablet:flex tablet:mx-[50px] mobile:mb-[40px] tablet:mb-0 tablet:flex-col tablet:justify-center tablet:items-center">
				<img class="tablet:m-5 tablet:h-[85px] mobile:h-[65px]" src="/assets/images/speech-bubbles.svg" />
				<p class="mobile:font-bold text-center tablet:font-light mobile:text-[16px] tablet:text-[24px]">{{ 'realTimeFeedback' | translate }}</p>
			</div>
			<div class="tablet:flex tablet:ml-[150px] mobile:mb-[40px] tablet:mb-0 tablet:flex-col tablet:justify-center tablet:items-center">
				<img class="tablet:m-5 tablet:h-[85px] mobile:h-[65px]" src="/assets/images/light-bulb.svg" />
				<p class="mobile:font-bold text-center tablet:font-light mobile:text-[16px] tablet:text-[24px]">{{ 'impactfulInsight' | translate }}</p>
			</div>
		</div>
		<div class="mobile:w-[80%] tablet:w-full justify-center tablet:items-end flex tablet:flex-row mobile:flex-col tablet:mt-[120px]">
			<div class="tablet:flex mobile:mb-[40px] tablet:mb-0 tablet:flex-col tablet:justify-center tablet:items-center">
				<img (click)="navigateToJottoSite()" src="/assets/images/{{ environment.whiteLabelImage || 'jotto-purple.png' }}" class="mobile:w-[45%] cursor-pointer tablet:w-[150px]" />
				<div>
					<a><p (click)="navigateToJottoSite()" class="font-semibold text-[18px] text-portals-theme-primary-text">{{ environment.whiteLabelDomain?.replace("https://", "") || 'www.jotto.me' }}</p></a>
				</div>
			</div>
			<div class="tablet:flex tablet:mx-[335px] tablet:flex-col tablet:justify-center tablet:items-center">
				<p class="mobile:font-bold tablet:font-light mobile:text-[16px] tablet:text-[24px]"></p>
			</div>
			<div class="tablet:flex tablet:flex-col tablet:justify-start mb-[12px] tablet:items-start">
				<p class="m-0 p-0 text-left font-bold leading-normal mobile:text-[16px] tablet:text-[11px]">©2024
                    {{ environment.whiteLabelDomain ? 'Quadrant 2' : 'Jotto' }}, Inc. {{
                        'rightsDisclaimer' | translate }}</p>
				<p class="m-0 p-0 font-light leading-normal mobile:text-[16px] tablet:text-[11px]">{{ 'photoCredits' | translate }}</p>
			</div>
		</div>
	</div>

	<button *ngIf="showScrollToNextPageBtn" id="gotoTop" class="hidden mobile:flex fixed bottom-8 right-5 bg-[#ffc700] border-[#491176] rounded-full border-2 w-[30px] h-[30px] p-1 justify-center items-center" (click)="scrollToTop()">
		<fa-icon icon="arrow-up-long" class="text-[#491176]" [style.line-height]="0"></fa-icon>
	</button>
</div>
